import useRevenueCat from "@utils/revenuecat";
import { formatTrialLabel } from "@utils/trialCountdown";
import React from "react";
import { useMe } from "@hooks/trpc/useMe";
import LBox from "@components/LBox";
import LButton from "@components/LButton";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { showPaywall } from "@components/Paywall";

const Subscription = () => {
  const { product, trialInfo } = useRevenueCat({ surface: "settings-subscription" });

  const { isPremium } = useMe();

  const openModal = () => {
    showPaywall();
  };

  const trialLabel =
    isPremium && trialInfo.data
      ? formatTrialLabel(trialInfo.data.periodType, trialInfo.data.expirationDate)
      : null;

  return (
    <LBox flex={1} mt="m1">
      <LText variant="bodyM2" color="homeGreeting" mb="s3">
        Your subscription
      </LText>
      <LBox flexDirection="row" gap="s2">
        <LIcon name={isPremium ? "premiumLogo" : "freemiumLogo"} size={48} />
        <LBox gap="s1" justifyContent={"center"}>
          <LText variant="bodyM2">{isPremium ? "Premium" : "Freemium"}</LText>
          {isPremium && (
            <LText variant="socialButton" color={"textGrey"}>
              {trialLabel ?? `Amount • ${product.priceString}`}
            </LText>
          )}
        </LBox>
      </LBox>
      {!isPremium && (
        <LBox mt="s3">
          <LButton
            sentryEventName="settings_open_subscription_modal"
            variant="primary"
            label="SUBSCRIBE"
            textVariant="bodyM2Transparent"
            borderRadius="max"
            onPress={openModal}
          />
        </LBox>
      )}
    </LBox>
  );
};

export default Subscription;
